export const P00061FonctionnementCompresseur = [
  { ref: 0, label: 'P00061.params.compresseur.normal' },
  { ref: 1, label: 'P00061.params.compresseur.boost' },
  { ref: 2, label: 'P00061.params.compresseur.eco' },
];
